import React, { useState, useEffect, Suspense } from "react";
import "./App.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SEOHead } from "./components/SEOHead";
import { WatchList } from "./components/WatchList";
import { InfoOverlay } from "./components/InfoOverlay";
import 'semantic-ui-css/semantic.min.css'

// Lazy load the Graph component (contains heavy dependencies: Three.js, react-force-graph, d3)
const Graph = React.lazy(() => import("./components/Graph"));

export default function App() {
  const [stockLoading, setStockLoading] = useState(true);
  const [cryptoLoading, setCryptoLoading] = useState(true);
  const [forexLoading, setForexLoading] = useState(true);
  const [assetType, setAssetType] = useState("Stock");

  const [stockTickers, setStockTickers] = useState([]);
  const [cryptoTickers, setCryptoTickers] = useState([]);
  const [forexTickers, setForexTickers] = useState([]);

  const [selectedTickers, setSelectedTickers] = useState([]);
  
  // Metrics cache shared between Graph and Header
  const [metricsCache, setMetricsCache] = useState({});
  const [metricsLoading, setMetricsLoading] = useState({});

  // Clear selected tickers when asset type changes
  useEffect(() => {
    setSelectedTickers([]);
  }, [assetType]);

  return (
    <div id="app" className={`app ${assetType === "Stock" ? "inverted" : ""} ${assetType === "Forex" ? "forex-theme" : ""}`}>
      <SEOHead assetType={assetType} />
      <Header 
        stockLoading={stockLoading}
        cryptoLoading={cryptoLoading}
        forexLoading={forexLoading}
        setAssetType={setAssetType}
        assetType={assetType}
        stockTickers={stockTickers}
        cryptoTickers={cryptoTickers}
        forexTickers={forexTickers}
        setSelectedTickers={setSelectedTickers}
        selectedTickers={selectedTickers}
      />
      <Suspense fallback={<div className="loader"></div>}>
        <Graph 
          setStockLoading={setStockLoading}
          setCryptoLoading={setCryptoLoading}
          setForexLoading={setForexLoading}
          assetType={assetType}
          setStockTickers={setStockTickers}
          setCryptoTickers={setCryptoTickers}
          setForexTickers={setForexTickers}
          selectedTickers={selectedTickers}
          setSelectedTickers={setSelectedTickers}
          metricsCache={metricsCache}
          setMetricsCache={setMetricsCache}
          metricsLoading={metricsLoading}
          setMetricsLoading={setMetricsLoading}
        />
      </Suspense>
      <WatchList assetType={assetType} setSelectedTickers={setSelectedTickers} />
      <InfoOverlay assetType={assetType} />
      <Footer />
    </div>
  );
}
